import { render, staticRenderFns } from "./AdminIdeaPostPage.vue?vue&type=template&id=7a3afd4c&scoped=true&"
import script from "./AdminIdeaPostPage.vue?vue&type=script&lang=ts&"
export * from "./AdminIdeaPostPage.vue?vue&type=script&lang=ts&"
import style0 from "./AdminIdeaPostPage.vue?vue&type=style&index=0&id=7a3afd4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a3afd4c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDivider,VRow})
